var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 99,
    viewBox: "0 0 133 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.851 0.62793H7.15312C3.75673 0.62793 1.00342 3.38125 1.00342 6.77764V91.6793C1.00342 95.0757 3.75673 97.829 7.15312 97.829H125.851C129.247 97.829 132 95.0757 132 91.6793V6.77764C132 3.38125 129.247 0.62793 125.851 0.62793Z",
    fill: "white",
    stroke: "#F2F2F2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87793 88.7817H123.066",
    stroke: "#F2F2F2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87793 73.416H123.066",
    stroke: "#F2F2F2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87793 58.0498H123.066",
    stroke: "#F2F2F2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87793 42.6714H123.066",
    stroke: "#F2F2F2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87793 27.2988H123.066",
    stroke: "#F2F2F2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.87793 11.9331H123.066",
    stroke: "#F2F2F2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8141 21.9365H21.0995C19.2345 21.9365 17.7227 23.4484 17.7227 25.3134V86.2339C17.7227 88.0989 19.2345 89.6107 21.0995 89.6107H28.8141C30.6791 89.6107 32.1909 88.0989 32.1909 86.2339V25.3134C32.1909 23.4484 30.6791 21.9365 28.8141 21.9365Z",
    fill: "#EAECF0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5148 48.3306H48.8002C46.9352 48.3306 45.4233 49.8424 45.4233 51.7074V86.2309C45.4233 88.0959 46.9352 89.6077 48.8002 89.6077H56.5148C58.3798 89.6077 59.8916 88.0959 59.8916 86.2309V51.7074C59.8916 49.8424 58.3798 48.3306 56.5148 48.3306Z",
    fill: "#EAECF0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2028 29.0137H76.4882C74.6232 29.0137 73.1113 30.5255 73.1113 32.3905V86.2142C73.1113 88.0791 74.6232 89.591 76.4882 89.591H84.2028C86.0677 89.591 87.5796 88.0791 87.5796 86.2142V32.3905C87.5796 30.5255 86.0677 29.0137 84.2028 29.0137Z",
    fill: "#EAECF0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M111.891 57.7793H104.176C102.311 57.7793 100.799 59.2912 100.799 61.1561V86.2217C100.799 88.0867 102.311 89.5985 104.176 89.5985H111.891C113.756 89.5985 115.268 88.0867 115.268 86.2217V61.1561C115.268 59.2912 113.756 57.7793 111.891 57.7793Z",
    fill: "#EAECF0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4092 52.3545L26.4532 52.0388L48.9793 75.1963L70.5307 55.5666L94.0176 63.2949L116.681 48.8267",
    stroke: "#98A2B3",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyBar);
export default __webpack_public_path__ + "static/media/emptyBar.496c0a32374565cba982497fbfa79ffa.svg";
export { ForwardRef as ReactComponent };